import styled from '@emotion/styled'

export const Body0 = styled.p(({ theme }) => ({
  fontFamily: theme.typography.family.default,
  fontSize: '1.75rem',
  lineHeight: 1.4285,
  fontWeight: 400,
  margin: 0,
  padding: 0,
}))
